// @ts-nocheck
class Company {

	#id;
	#offerId;
	#companyName;
	#totalUsers;
	#totalSites;
	#superAdminId;
	#lastChanged;
	#lastChangeAuthorId;
	#statTemplateId;
	#creationDate;

	constructor(props) {
		this.#id = (props?.id ? props.id : null);
		this.#offerId = (props?.offerId ? props.offerId : null);
		this.#companyName = (props?.companyName ? props.companyName : null);
		this.#totalUsers = (props?.totalUsers ? props.totalUsers : 0);
		this.#totalSites = (props?.totalSites ? props.totalSites : 0);
		this.#superAdminId = (props?.superAdminId ? props.superAdminId : null);
		this.#lastChanged = (props?.lastChanged ? props.lastChanged : null);
		this.#lastChangeAuthorId = (props?.lastChangeAuthorId ? props.lastChangeAuthorId : null);
		this.#statTemplateId = (props?.statTemplateId ? props.statTemplateId : null);
		this.#creationDate = (props?.creationDate ? props.creationDate : null);
	}

	companyId(setCompanyId) {
		if (typeof setCompanyId !== "undefined")
			this.#id = setCompanyId;
		return (this.#id);
	}

	offerId(setOfferId) {
		if (typeof setOfferId !== "undefined")
			this.#offerId = setOfferId;
		return (this.#offerId);
	}

	name(setName) {
		if (typeof setName !== "undefined")
			this.#companyName = setName;
		return (this.#companyName);
	}

	totalUsers(setTotalUsers) {
		if (typeof setTotalUsers !== "undefined")
			this.#totalUsers = setTotalUsers;
		return (this.#totalUsers);
	}

	totalSites(setTotalSites) {
		if (typeof setTotalSites !== "undefined")
			this.#totalSites = setTotalSites;
		return (this.#totalSites);
	}

	superAdminId(setSuperAdminId) {
		if (typeof setSuperAdminId !== "undefined")
			this.#superAdminId = setSuperAdminId;
		return (this.#superAdminId);
	}

	lastChanged(setLastChanged) {
		if (typeof setLastChanged !== "undefined")
			this.#lastChanged = setLastChanged;
		return (this.#lastChanged);
	}

	lastChangeAuthorId(setLastChangeAuthorId) {
		if (typeof setLastChangeAuthorId !== "undefined")
			this.#lastChangeAuthorId = setLastChangeAuthorId;
		return (this.#lastChangeAuthorId);
	}

	statTemplateId(setStatTemplateId) {
		if (typeof setStatTemplateId !== "undefined")
			this.#statTemplateId = setStatTemplateId;
		return (this.#statTemplateId);
	}

	creationDate(setCreationDate) {
		if (typeof setCreationDate !== "undefined")
			this.#creationDate = setCreationDate;
		return (this.#creationDate);
	}

	values = () => ({
		id: this.#id,
		offerId: this.#offerId,
		companyName: this.#companyName,
		totalUsers: this.#totalUsers,
		totalSites: this.#totalSites,
		superAdminId: this.#superAdminId,
		lastChanged: this.#lastChanged,
		lastChangeAuthorId: this.#lastChangeAuthorId,
		statTemplateId: this.#statTemplateId,
		creationDate: this.#creationDate
	});
}

export default Company;
